module.exports = __webpack_public_path__ + "img/teste2.048fcb2b.jpg";